export const defaultParams =
{
    typeUser: {
        client: false,
        employee: false,
        provider: false
    },
    date_generate: null,
    mainThird: [],
    thirdBranch: []

}



export default {
    params: defaultParams

}


// WEBPACK FOOTER //
// ./src/modules/inventory-users/state.js